import { useQueryClient } from "@tanstack/react-query"

export default function useInvalidateStudyPlannerQueries() {
  const queryClient = useQueryClient()

  const handleInvalidateQueries = () => {
    queryClient.invalidateQueries({
      queryKey: ["study-get-activities"],
    })
    queryClient.invalidateQueries({
      queryKey: ["get-daily-calendar"],
    })
    queryClient.invalidateQueries({
      queryKey: ["planner-get-weekly-objectives"],
    })
  }

  return handleInvalidateQueries
}
